import styled from 'styled-components';

export const LiveArenaWidgetClockBox = styled.div`
    display: flex;
    height: 100%;
    flex-direction: column;
    justify-items: center;
    justify-content: center;
    
    div {
        font-size: 25px;
        color: ${props => props.theme.components.partyJackpotInGameWidget.colors.timer};

        @media ${props => props.theme.mediaQuery.lAndBelow} {
            font-size: 17px;
        }
    }
`;
